<template>
  <div class="container">
    <h1 class="mb-4">Corte {{ savings_cut.cut_day }} de {{ savings_cut.month }} del {{ savings_cut.year }}</h1>

    <div class="row pb-5">
      <sys-widget title="Cantidad de Cuentas" :content="savings_cut.account_count" icon="users" size="3"/>
      <sys-widget title="Monto Disponible" :content="savings_cut.amount | formatCurrency" icon="dollar-sign" color="secondary" size="3"/>
      <sys-widget title="Monto Total" :content="savings_cut.amount_total | formatCurrency" icon="dollar-sign" color="secondary" size="3"/>
    </div>

    <div class="details">
      <div class="details__head row pl-3">
        <ul class="nav nav-tabs col-sm-9" role="tablist">
          <li class="nav-item tabs-item">
            <a class="nav-link active" data-toggle="tab" role="tab" href="#accounts"><fai icon="credit-card"/>
              &nbsp;Cuentas de Ahorro
            </a>
          </li>
          <li class="nav-item tabs-item">
            <a class="nav-link" data-toggle="tab" role="tab" href="#send-mail"><fai icon="envelope"/>
              &nbsp;Envío de estado de cuenta
            </a>
          </li>
          <li class="nav-item tabs-item">
            <a class="nav-link" data-toggle="tab" role="tab" href="#log"><fai icon="list"/>
              &nbsp;Reporte de correos
            </a>
          </li>
        </ul>
        <div class="col-sm-3 text-right" v-if="savings_cut.status">
          <button class="btn btn-success" @click="recalculateCut" v-if="savings_cut.status != 'Aprobado'">
            <fai :icon="['fas','calculator']"/> Recalcular
          </button>
          <button class="btn btn-green text-white" @click="completeCut" v-if="savings_cut.status != 'Aprobado'">
            <fai :icon="['fas','clipboard-check']"/> Completar Corte
          </button>
          <span class="pull-right" v-if="savings_cut.status == 'Aprobado'">
            <h2 class="font-primary">{{ savings_cut.status }}</h2>
          </span>
        </div>
      </div>
      <div class="details__body mt-4">
        <div class="tab-content">
          <!--begin: Attachments -->
          <div id="accounts" class="tab-pane fade show active" role="tabpanel">
            <sys-table :headers="accounts_headers" :items="accounts" title="Ahorros" title_icon="credit-card"/>
          </div>
          <!--end: Attachments -->
          <!--begin: Payments -->
          <!--div id="payments" class="tab-pane fade" role="tabpanel" v-if="savings_cut.status == 'Aprobado'">
            <button class="btn btn-success" @click="getDispersion">
              <fai :icon="['fas','download']"/> TXT Banorte
            </button>
            <button class="btn btn-green text-white" @click="getDispersionInter">
              <fai :icon="['fas','download']"/> TXT Interbancario
            </button>
            <sys-table :headers="payment_headers" :items="payments" title="Pagos" title_icon="credit-card"/>
          </div-->
          <!--end: Payments -->
          <!--begin: Email -->
          <div id="send-mail" class="tab-pane fade" role="tabpanel">
            <div class="row">
              <div class="col">
                <h2>Envío de correos</h2>
              </div>
            </div>
            <sys-form ref="formStatements" :inputs="mail_info"/>
            <div class="row mt-4">
              <div class="col">
                <h5>Cuentas</h5>
              </div>
            </div>
            <sys-table ref="tableStatements" :headers="statements_headers" :items="accounts" :selectable="true"/>
            <div class="row">
              <div class="col-sm-12 text-right" v-if="savings_cut.status == 'Aprobado'">
                <button v-if="generationInProcess == false" class="btn btn-warning" @click="generateStatements">
                  <fai :icon="['far','file']"/>Generar Estados de Cuenta
                </button>
                <button v-else class="btn btn-warning" style="opacity: 0.5; cursor: initial;">
                  <fai :icon="['far','file']"/> Generar Estados de Cuenta
                </button>
                &nbsp;
                <button v-if="sendInProcess == false" class="btn btn-green text-white" @click="sendStatements">
                  <fai :icon="['fas','envelope']"/> Enviar Estados de Cuenta
                </button>
                <button v-else class="btn btn-green text-white" style="opacity: 0.5; cursor: initial;">
                  <fai :icon="['fas','envelope']"/> Enviar Estados de Cuenta
                </button>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <p class="text-danger" v-if="error">
                  {{ error }}
                </p>
              </div>
            </div>
          </div>
          <!--end: Email -->
          <!--begin: Email Log -->
          <div id="log" class="tab-pane fade" role="tabpanel">
            <sys-table :headers="log_headers" :items="logs" title="Bitacora de envío" error_message="No se encontraron envíos" title_icon="list"/>
          </div>
          <!--end: Email Log -->
        </div>
      </div>
      <complete-savings-cut :savings_cut="savings_cut"
                    @savingsCutCompleted="onSavingsCutCompleted">
      </complete-savings-cut>
    </div>
  </div>
</template>

<script>
import * as $ from 'jquery'
import savingsCutService from '@/services/savings_cuts'
import SysTable from '@/components/shared/Table'
import SysWidget from '@/components/shared/Widget'
import SysForm from '@/components/shared/Form'
import formMixin from '@/mixins/form'
import CompleteSavingsCut from './CompleteSavingsCut'
import formatCurrency from '@/filters/formatCurrency'
import reverseDate from '@/filters/reverseDate'

export default {
  name: 'SavingsCutDetail',
  components: { SysTable, SysForm, SysWidget, CompleteSavingsCut },
  mixin: [ formMixin ],

  data () {
    return {
      savings_cut: {},
      isDisabled: false,
      error: null,
      file_url: null,
      generationInProcess: false,
      sendInProcess: false,
      accounts_headers: [
        { text: 'Id', value: 'id' },
        { text: 'Colaborador', value: 'colaborator' },
        { text: 'Fecha de Inicio', value: 'init_date', reverseDate },
        { text: 'Fecha de Fin', value: 'end_date', reverseDate },
        { text: 'Acción Inicial', value: 'init_action' },
        { text: 'Acción Final', value: 'end_action' },
        { text: 'Días calculados', value: 'days_calculated' },
        { text: 'Saldo Anterior', value: 'amount', filter: formatCurrency }
      ],
      statements_headers: [
        { text: 'Id', value: 'id' },
        { text: 'Nombre', value: 'colaborator' },
        { text: 'Saldo Anterior', value: 'amount', filter: 'formatCurrency', class: 'text-right' },
        { text: 'Salario', value: 'salary', filter: 'formatCurrency', class: 'text-right' },
        { text: 'Porcentaje', value: 'percent' },
        { text: 'Ahorro Acumulado', value: 'account_amount', filter: 'formatCurrency', class: 'text-right' },
        { text: 'Estado de Cuenta', value: 'statement3', link: false, statement: true, class: 'text-center' }
      ],
      accounts: [],
      log_headers: [
        { text: 'Colaborador', value: 'account_name' },
        { text: 'Correo', value: 'email' },
        { text: 'Asunto', value: 'subject' },
        { text: 'Enviado', value: 'created_at' },
        { text: 'Respuesta', value: 'event', class: 'text-center font-weight-bold' },
        { text: 'Mensaje', value: 'message' },
        { text: 'Leído', value: 'timestamp' }
      ],
      logs: [],
      mail_info: {
        subject: {
          name: 'Asunto',
          hint: 'Asunto',
          value: '',
          type: 'text',
          validate: 'required',
          size: 6
        },
        bcc: {
          name: 'BCC',
          hint: 'Correos ocultos (separados por coma)',
          value: '',
          type: 'text',
          size: 6
        },
        email: {
          name: 'Email',
          hint: 'Remitente',
          value: '',
          type: 'email',
          size: 6
        },
        sender: {
          name: 'Nombre',
          hint: 'Nombre del Remitente',
          value: '',
          type: 'text',
          size: 6
        },
        message: {
          name: 'Mensaje',
          hint: 'Escribe el cuerpo del correo',
          value: '',
          type: 'textarea',
          validate: 'required',
          size: 12
        }
      }
    }
  },
  beforeCreate: function () {
    const id = this.$route.params.id

    savingsCutService.getById(id).then(res => {
      this.savings_cut = res.data
    })

    savingsCutService.getLogs(id).then(res => {
      this.logs = res.data
    })
  },
  created: function () {
    const id = this.$route.params.id
    savingsCutService.getAccounts(id).then(res => {
      this.accounts = res.data
    })
  },
  methods: {
    recalculateCut () {
      savingsCutService.updateById(this.$route.params.id).then(res => {
        this.$router.go(this.$router.currentRoute)
      }).catch(err => {
        console.log(JSON.stringify(err.data))
      })
    },
    generateStatements: function () {
      let body = {}
      body['accounts'] = this.$refs.tableStatements.selected.join(',')

      this.generationInProcess = true
      savingsCutService.generateStatements(this.$route.params.id, body).then(res => {
        if (res.error) {
          this.error = res.error
          this.generationInProcess = false
        } else {
          this.error = null
          this.$router.go(this.$router.currentRoute)
        }
      }).catch(err => {
        console.log(JSON.stringify(err.data))
      })
    },
    sendStatements: function () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          let body = {}

          body['subject'] = this.$refs.formStatements.inputs.subject.value
          body['bcc'] = this.$refs.formStatements.inputs.bcc.value
          body['email'] = this.$refs.formStatements.inputs.email.value
          body['sender_name'] = this.$refs.formStatements.inputs.sender.value
          body['message'] = this.$refs.formStatements.inputs.message.value
          body['accounts'] = this.$refs.tableStatements.selected.join(',')

          this.sendInProcess = true
          savingsCutService.sendStatements(this.$route.params.id, body).then(res => {
            if (res.error) {
              this.error = res.error
              this.sendInProcess = false
            } else {
              this.error = null
              alert(res.message)
              const id = this.$route.params.id
              savingsCutService.getLogs(id).then(res => {
                this.logs = res.data
              })
              this.sendInProcess = false
            }
          }).catch(err => {
            console.log(JSON.stringify(err.data))
          })
        }
      })
    },
    completeCut: function () {
      $('#complete-saving-cut').modal()
    },
    onSavingsCutCompleted: function () {
      window.location.reload()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/savings_cuts/SavingsCutDetail.vue